export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12134.a8f7cbe5.jpg";